<template>
	<expand-list-modal
		ref="$modal"
		title="Клиенты"
		placeholder="Название или адрес"
		:filter="filter"
		@update:filter="filter = $event"
	>
		<div
			v-if="!filteredClients.length"
			class="clients-expand__empty"
		>
			Ничего не найдено
		</div>

		<div
			v-for="(ac, index) in filteredClients"
			:key="ac.Id"
			class="clients-expand__row"
		>
			<div class="clients-expand__row-left">
				<div class="clients-expand__row-count">{{ index + 1 }}.</div>
				<div class="clients-expand__row-name">
					<router-link
						class="clients-expand__row-name-str"
						:to="{ query: { page: 'client', id: ac.Id } }"
						@click="onClose"
					>
						{{ ac.Name }}
					</router-link>
					<span
						v-if="ac.Address"
						class="clients-expand__row-address"
					>
						({{ ac.Address }})
					</span>
					<app-tooltip
						v-if="canEdit"
						text="Удалить"
					>
						<template #activator>
							<app-icon
								class="clients-expand__row-icon"
								:style="{ marginTop: '-2px' }"
								name="close-bold"
								width="12px"
								color="#D2D2D2"
								hover-color="#BA4C4C"
								cursor="pointer"
								@click="onDetach(ac.Id)"
							/>
						</template>
					</app-tooltip>
					<span
						v-if="ac.Roles?.length"
						class="clients-expand__row-roles"
					>
						<span
							v-for="role in ac.Roles"
							:key="role.Id"
							class="clients-expand__row-roles-item"
						>
							<span class="clients-expand__row-roles-item-name">{{ role.Name }}</span>
							<app-tooltip
								v-if="canEdit"
								text="Удалить"
							>
								<template #activator>
									<app-icon
										class="clients-expand__row-icon"
										:style="{ marginTop: '-2px' }"
										name="close-bold"
										width="12px"
										color="#D2D2D2"
										hover-color="#BA4C4C"
										cursor="pointer"
										@click="onDetachRole(ac.Id, role.Id)"
									/>
								</template>
							</app-tooltip>
						</span>
					</span>
				</div>
			</div>
		</div>
	</expand-list-modal>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import ExpandListModal from "@/components/common/modal/ExpandListModal.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import { projectPageStore } from "@/store/project-page";

const projectStore = projectPageStore()

const project = computed(() => projectStore.openedProject)
const canEdit = computed(() => project.value?.AttachedClientsAccess === 2)

const filter = ref('')

const filteredClients = computed(() => {
	const list = project.value?.AttachedClients ?? []
	const q = filter.value.trim().toLowerCase()
	if (!q) {
		return list
	}
	return list.filter((ac: any) =>
		`${ac.Name ?? ''} ${ac.Address ?? ''}`.toLowerCase().includes(q)
	)
})

const $modal = ref<InstanceType<typeof ExpandListModal> | null>(null)

const onOpen = () => {
	filter.value = ''
	$modal.value?.onOpen()
}
const onClose = () => $modal.value?.onClose()

const onDetach = async (id: number) => {
	try {
		await projectStore.detachClientFromProject(id)
	} catch (e) {
		console.error(e)
	}
}

const onDetachRole = async (clientId: number, roleId: number) => {
	try {
		await projectStore.detachRoleFromClient(clientId, roleId)
	} catch (e) {
		console.error(e)
	}
}

defineExpose({ onOpen, onClose })
</script>

<style scoped lang="scss">
.clients-expand {
	&__empty {
		font-size: 14px;
		line-height: 18px;
		color: #979797;
		padding: 4px 0;
	}

	&__row {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;

		&-left {
			display: flex;
			align-items: flex-start;
			font-size: 14px;
			line-height: 18px;
			gap: 2px;
			flex-wrap: wrap;
		}

		&-count {
			margin: 0 2px 0 3px;
			color: #4D4D4D;
		}

		&-name {
			color: #4D4D4D;

			&-str {
				color: #4D4D4D;
				text-decoration: none;

				&:hover {
					color: #499259;
				}
			}
		}

		&-address {
			white-space: nowrap;
			color: #4D4D4D;
		}

		&-roles {
			display: inline-flex;
			flex-wrap: wrap;
			align-items: center;
			gap: 4px;
			margin-left: 6px;

			&-item {
				display: inline-flex;
				align-items: center;
				gap: 2px;
				padding: 0 4px;
				border-radius: 4px;
				background: #F1F1F1;

				&-name {
					font-size: 12px;
					line-height: 16px;
					color: #4D4D4D;
				}
			}
		}
	}
}
</style>
